import { getUtcDateTimeISOString, convertDateToUtc } from "../../common/helpers/dateHelpers";
import { getDateRange } from "../helpers/filter/dateRange";

const getCalendarBaseUrl = (config) => {
    const defaultCalendarApiUrl = CALENDAR_API_URL;

    const calendarBaseUrl = config.calendarApiUrl || defaultCalendarApiUrl;
    const result = `${calendarBaseUrl}/${config.culture}`;
    return result;
};

const urlFactory = {
    getEventDates: (config, settings, path, apiVersionParam = null) => {
        const dateRange = getDateRange(settings.filter, settings.timezoneOffset);
        const dateFromUtc = convertDateToUtc(dateRange.from, settings.timezoneOffset);
        const dateToUtc = convertDateToUtc(dateRange.to, settings.timezoneOffset);
        const calendarBaseUrl = getCalendarBaseUrl(config);
        const dateFromParam = getUtcDateTimeISOString(dateFromUtc);
        const dateToParam = getUtcDateTimeISOString(dateToUtc);
        const volatilities = settings.filter.volatilities;
        const countries = settings.filter.countries;
        const categories = settings.filter.categories;
        const apiVersion = apiVersionParam ?? config.calendarApiVersion ?? "v1";

        let result = `${calendarBaseUrl}/api/${apiVersion}/eventDates/${dateFromParam}/${dateToParam}${path || ""}`;
        let query = "";

        if (volatilities && volatilities.length > 0) volatilities.forEach((vol) => (query = `${query}&volatilities=${vol}`));

        if (countries && countries.length > 0) countries.forEach((country) => (query = `${query}&countries=${country}`));

        if (categories && categories.length > 0) categories.forEach((category) => (query = `${query}&categories=${category}`));

        if (query) result = `${result}?${query}`;

        return result;
    },
    getEventDateDetails: (config, eventDateId) => {
        const calendarBaseUrl = getCalendarBaseUrl(config);
        const result = `${calendarBaseUrl}/api/v1/eventDates/${eventDateId}`;
        return result;
    },
    getEventDateICalendar: (config, eventDateId) => {
        const calendarBaseUrl = getCalendarBaseUrl(config);
        const result = `${calendarBaseUrl}/api/v1/eventDates/${eventDateId}`;
        return result;
    },
    getEventDatesICalendar(config, settings, apiVersionParam = null) {
        const result = urlFactory.getEventDates(config, settings, "", apiVersionParam);
        return result;
    },
};

export { urlFactory };
